/**
 * store for gfo webcomponent
 * Both states are set in OrderForSelection.vue
 * And in ResellerGfoCheckout.vue
 * Concept: 
 * - load and parse cookie gfo_order_for
 * - check if the gfo_order_for.order_for_number is valid for the PAR
 * - if valid commit("order_for", gfo_order_for)
 * - if not valid commit("order_for", gfo_order_for_new_customer)
 */
import {setCookie} from "@/plugins/cookie.js"

export default {
  namespaced: true,
  state: {
    order_for: null,

    order_for_choices: []

  },
  mutations: {
    order_for(state, value){
      if (typeof(value) != "object" 
      || !value.hasOwnProperty("order_by_number")
      || !value.hasOwnProperty("order_for_number")
      || !value.hasOwnProperty("order_for_name")
      ) {
        console.log(value, "kann nicht gespeichert werden als order_for")
      } else {
        state.order_for = value
        setCookie("gfo_order_for", JSON.stringify(value))
      }
    },
    order_for_choices(state, value){
      state.order_for_choices = value
    } 
  },

     
};
